export default __webpack_public_path__ + "static/media/eb-ultra-wht-poster-1.f5a2a5c0.jpg";